var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"align-center":""}},[_c('v-flex',{staticClass:"about-logo-center",attrs:{"xs12":"","sm6":"","offset-sm3":"","text-xs-center":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('img',{staticClass:"slashdr--logo",attrs:{"src":"/static/logo-about.png"}})]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Web App: "+_vm._s(_vm.webAppVersion))])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07aaa046","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/about.vue
// module id = null
// module chunks = 